export default __webpack_public_path__ + "static/media/large-crumb2-pause.51ea2660.png";